import api from "../services/api"

export async function getFunctionControlDeliveryData({ orderID, productID }) {
  if (productID) {
    orderID = null
  }
  const requestData = await api.get(
    "/api/v1/product/functioncontrol/delivery",
    {
      params: {
        orderID,
        productID,
      },
    }
  )

  return requestData.data
}

export async function getFunctionControlDeliveryOptions({
  orderID,
  productID,
}) {
  const requestData = await api.get(
    "/api/v1/product/functioncontrol/delivery/options",
    {
      params: {
        orderID,
        productID,
      },
    }
  )

  return requestData.data
}

export async function saveFunctionControlDelivery({
  orderID,
  productID,
  functionControlDelivery,
  functionControlMethod,
}) {
  const requestData = await api.post(
    "/api/v1/product/functioncontrol/delivery",
    {
      ...functionControlDelivery,
      functionControlMethod,
    },
    {
      params: {
        orderID,
        productID,
      },
    }
  )

  return requestData.data
}

export async function getFunctionControlMaintenanceData({
  productID,
  customerID,
}) {
  const requestData = await api.get(
    "/api/v1/product/functioncontrol/maintenance",
    {
      params: {
        productID,
        customerID,
      },
    }
  )

  return requestData.data
}

export async function getFunctionControlMaintenanceOptions({ productID }) {
  const requestData = await api.get(
    "/api/v1/product/functioncontrol/maintenance/options",
    {
      params: {
        productID,
      },
    }
  )

  return requestData.data
}

export async function saveFunctionControlMaintenance({
  productID,
  functionControlMaintenance,
  customerID,
}) {
  const requestData = await api.post(
    "/api/v1/product/functioncontrol/maintenance",
    functionControlMaintenance,
    {
      params: {
        productID,
        customerID,
      },
    }
  )

  return requestData.data
}
